function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { DropdownToggle, UncontrolledDropdown, DropdownMenu } from 'reactstrap';
import { kebabCase, startCase, camelCase } from 'lodash';
import Icon from '../common/containers/icon';
import * as paths from '../../utils/paths';
import entityComposition from '../common/classes/entityComposition';
import MenuDropdownItem from './menuDropdownItem';
import processLegacyCabinets from './legacyCabinets';
import { checkPermission, makeResource } from '../../../behaviors/src/lib/permissions';
import { getUser } from '../common/classes/permissions';
const AdminMenu = ({
  adminCabinets: _adminCabinets = [],
  otherCabinets: _otherCabinets = [],
  hasSupersetToken: _hasSupersetToken = false,
  variant: _variant = 'header',
  expanded: _expanded = false,
  drawerOpen: _drawerOpen = false,
  mobileNavHidden: _mobileNavHidden = false,
  onCloseDrawer: _onCloseDrawer = undefined
}) => {
  var _permissions$general, _permissions$general2, _permissions$summarie, _permissions$general3, _permissions$general4, _permissions$general5;
  const {
    hasAdminSectionPermission,
    getPermissions
  } = paths;
  const permissions = getPermissions();
  const user = getUser();
  const jobOrUserEdit = ((_permissions$general = permissions.general) === null || _permissions$general === void 0 ? void 0 : _permissions$general.includes('job_edit')) || ((_permissions$general2 = permissions.general) === null || _permissions$general2 === void 0 ? void 0 : _permissions$general2.includes('user_edit'));
  const checkAdminPermission = section => jobOrUserEdit && hasAdminSectionPermission(section);
  const hardCodedMenuItems = {
    jobs: {
      identifier: 'jobs',
      sortOrder: 0,
      isPermittedToViewMenu: checkAdminPermission('jobs'),
      glyph: 'list'
    },
    employees: {
      identifier: 'employees',
      sortOrder: 1,
      isPermittedToViewMenu: checkAdminPermission('employees'),
      glyph: 'user'
    },
    summaries: {
      identifier: 'summaries',
      sortOrder: 2,
      isPermittedToViewMenu: ((_permissions$summarie = permissions.summaries) === null || _permissions$summarie === void 0 ? void 0 : _permissions$summarie.length) && checkAdminPermission('summaries'),
      glyph: 'download'
    },
    organizations: {
      identifier: 'organizations',
      sortOrder: 3,
      isPermittedToViewMenu: checkAdminPermission('organizations'),
      glyph: 'home'
    },
    pickerMenu: {
      identifier: 'pickers',
      sortOrder: 4,
      isPermittedToViewMenu: (_permissions$general3 = permissions.general) === null || _permissions$general3 === void 0 ? void 0 : _permissions$general3.includes('picker_edit'),
      glyph: 'sticky-note'
    },
    contractSpec: {
      identifier: 'contractSpecs',
      sortOrder: 5,
      isPermittedToViewMenu: checkAdminPermission('contractSpec'),
      glyph: 'list-alt'
    },
    reportTags: {
      identifier: 'reportTags',
      sortOrder: 6,
      isPermittedToViewMenu: checkAdminPermission('reportTags'),
      glyph: 'tags'
    },
    dashboard: {
      identifier: 'dashboard',
      sortOrder: 7,
      isPermittedToViewMenu: (_permissions$general4 = permissions.general) === null || _permissions$general4 === void 0 ? void 0 : _permissions$general4.includes('dashboard')
    },
    settings: {
      identifier: 'settings',
      sortOrder: 8,
      isPermittedToViewMenu: false // not yet implemented on web
    },
    userGuide: {
      identifier: 'userGuide',
      sortOrder: 9,
      isPermittedToViewMenu: false // not yet implemented on web
    },
    design: {
      identifier: 'design',
      sortOrder: 10,
      isPermittedToViewMenu: false // not yet implemented on web
    },
    appendix8: {
      identifier: 'appendix8',
      sortOrder: 11,
      isPermittedToViewMenu: false // not yet implemented on web
    },
    whatsNew: {
      identifier: 'whatsNew',
      sortOrder: 12,
      isPermittedToViewMenu: false // not yet implemented on web
    },
    announcements: {
      identifier: 'announcements',
      sortOrder: 13,
      isPermittedToViewMenu: false // not yet implemented on web
    }
  };
  const validAdminMenuOptions = [];

  // Add permitted hardcoded admin sections
  Object.keys(hardCodedMenuItems).forEach(section => {
    if (permissions.adminSections.includes(section)) {
      validAdminMenuOptions.push(hardCodedMenuItems[section]);
    }
  });

  // The picker edit is intended to exist under the admin menu options
  // but the permission for picker edit lives under permissions.general
  // section so it must be checked as well and included in validAdminMenuOptions if present.
  if ((_permissions$general5 = permissions.general) !== null && _permissions$general5 !== void 0 && _permissions$general5.includes('picker_edit')) {
    validAdminMenuOptions.push(hardCodedMenuItems.pickerMenu);
  }

  // configurable cabinets with tabGroup.identifier = 'admin'
  // processLegacyCabinets maps legacy admin cabinets onto their admin route
  // (legacyJobs -> /admin/jobs); anything else falls back to /cabinets/{identifier}.
  processLegacyCabinets(_adminCabinets).forEach(adminCabinet => {
    const {
      identifier,
      title,
      path,
      formTypeIdentifiers = [],
      client: {
        web: {
          layout: {
            superset
          } = {},
          icon: glyph = 'folder-open',
          tabGroup: {
            sortOrder = validAdminMenuOptions.length
          } = {}
        }
      }
    } = adminCabinet;
    const isPermittedToViewMenu = formTypeIdentifiers.some(ft => checkPermission(makeResource('form', ft), 'view_list', permissions, user));
    validAdminMenuOptions.push({
      glyph,
      identifier,
      title,
      isPermittedToViewMenu: superset ? _hasSupersetToken : isPermittedToViewMenu,
      path: `/#${path}`,
      sortOrder,
      isConfigurableCabinet: true
    });
  });

  // A legacy cabinet outside the admin tab group owns its surface from that group instead —
  // carboline lists Pickers under Archive — so the hardcoded section must not repeat it here.
  const cabinetOwnedHrefs = new Set(processLegacyCabinets(_otherCabinets).map(({
    path
  }) => `/#${path}`));

  // An AdminSection row and an admin tab-group cabinet can describe the same surface —
  // `jobs` and `legacyJobs` both resolve to /#/admin/jobs — so collapse matching hrefs into
  // one item. The section keeps its identifier (stable class name) and the cabinet supplies
  // the account's configured title, icon, and sort order.
  const permittedOptionsByHref = new Map();
  validAdminMenuOptions.filter(({
    isPermittedToViewMenu
  }) => isPermittedToViewMenu).map(option => {
    var _option$path;
    return _objectSpread(_objectSpread({}, option), {}, {
      href: (_option$path = option.path) !== null && _option$path !== void 0 ? _option$path : `/#/admin/${option.identifier}`
    });
  }).filter(({
    isConfigurableCabinet,
    href
  }) => isConfigurableCabinet || !cabinetOwnedHrefs.has(href)).forEach(option => {
    const {
      href
    } = option;
    const existing = permittedOptionsByHref.get(href);
    if (!existing) {
      permittedOptionsByHref.set(href, option);
      return;
    }
    const section = option.isConfigurableCabinet ? existing : option;
    const cabinet = option.isConfigurableCabinet ? option : existing;
    permittedOptionsByHref.set(href, _objectSpread(_objectSpread({}, cabinet), {}, {
      identifier: section.identifier
    }));
  });

  // Sorts and renders the item component
  const adminOptions = [...permittedOptionsByHref.values()].sort((a, b) => a.sortOrder - b.sortOrder).map(({
    glyph: _glyph = 'chart-bar',
    identifier,
    href,
    title: _title = startCase(camelCase(identifier))
  }) => /*#__PURE__*/React.createElement(MenuDropdownItem, {
    key: identifier,
    className: `t-h-nav-admin-${kebabCase(identifier)}`,
    title: _title,
    glyph: _glyph,
    href: href,
    onClick: _onCloseDrawer
  }));
  if (adminOptions.length === 0) {
    return null;
  }
  if (_variant === 'sidebar') {
    const showLabels = _expanded || _drawerOpen;
    return /*#__PURE__*/React.createElement("li", {
      className: "global-nav-sidebar__item t-h-nav-admin t-h-nav-admin-dropdown"
    }, /*#__PURE__*/React.createElement(UncontrolledDropdown, {
      direction: "right"
    }, /*#__PURE__*/React.createElement(DropdownToggle, {
      tag: "button",
      type: "button",
      className: "global-nav-sidebar__link global-nav-sidebar__link--dropdown",
      "aria-label": !showLabels ? 'Admin' : undefined,
      title: !showLabels ? 'Admin' : undefined,
      tabIndex: _mobileNavHidden ? -1 : undefined,
      disabled: _mobileNavHidden || undefined
    }, /*#__PURE__*/React.createElement("span", {
      className: "global-nav-sidebar__icon"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "cog"
    })), /*#__PURE__*/React.createElement("span", {
      className: "global-nav-sidebar__label"
    }, "Admin")), /*#__PURE__*/React.createElement(DropdownMenu, {
      positionFixed: true,
      className: "global-nav-sidebar__dropdown-menu",
      modifiers: {
        preventOverflow: {
          enabled: true,
          boundariesElement: 'viewport',
          padding: 8
        }
      }
    }, adminOptions)));
  }
  return /*#__PURE__*/React.createElement(UncontrolledDropdown, {
    nav: true,
    inNavbar: true,
    className: "t-h-nav-admin-dropdown",
    key: "dropdownMenu",
    id: "adminDropdownMenu",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(DropdownToggle, {
    nav: true,
    caret: true
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "cog"
  }), /*#__PURE__*/React.createElement("br", null), "Admin"), /*#__PURE__*/React.createElement(DropdownMenu, null, adminOptions));
};
AdminMenu.propTypes = {
  adminCabinets: PropTypes.arrayOf(PropTypes.shape({})),
  otherCabinets: PropTypes.arrayOf(PropTypes.shape({})),
  hasSupersetToken: PropTypes.bool,
  variant: PropTypes.oneOf(['header', 'sidebar']),
  expanded: PropTypes.bool,
  drawerOpen: PropTypes.bool,
  mobileNavHidden: PropTypes.bool,
  onCloseDrawer: PropTypes.func
};
export { AdminMenu as TestAdminMenu };
export default entityComposition(AdminMenu, ['settings'], {
  adminCabinets: state => {
    var _state$settings;
    return state === null || state === void 0 || (_state$settings = state.settings) === null || _state$settings === void 0 || (_state$settings = _state$settings.settings) === null || _state$settings === void 0 || (_state$settings = _state$settings.cabinetDefinitions) === null || _state$settings === void 0 ? void 0 : _state$settings.filter(cd => {
      var _cd$client;
      return (cd === null || cd === void 0 || (_cd$client = cd.client) === null || _cd$client === void 0 || (_cd$client = _cd$client.web) === null || _cd$client === void 0 || (_cd$client = _cd$client.tabGroup) === null || _cd$client === void 0 ? void 0 : _cd$client.identifier) === 'admin';
    });
  },
  otherCabinets: state => {
    var _state$settings2;
    return state === null || state === void 0 || (_state$settings2 = state.settings) === null || _state$settings2 === void 0 || (_state$settings2 = _state$settings2.settings) === null || _state$settings2 === void 0 || (_state$settings2 = _state$settings2.cabinetDefinitions) === null || _state$settings2 === void 0 ? void 0 : _state$settings2.filter(cd => {
      var _cd$client2;
      return (cd === null || cd === void 0 || (_cd$client2 = cd.client) === null || _cd$client2 === void 0 || (_cd$client2 = _cd$client2.web) === null || _cd$client2 === void 0 || (_cd$client2 = _cd$client2.tabGroup) === null || _cd$client2 === void 0 ? void 0 : _cd$client2.identifier) !== 'admin';
    });
  },
  hasSupersetToken: state => {
    var _state$login;
    return (state === null || state === void 0 || (_state$login = state.login) === null || _state$login === void 0 || (_state$login = _state$login.user) === null || _state$login === void 0 || (_state$login = _state$login.superset) === null || _state$login === void 0 || (_state$login = _state$login.dashboards) === null || _state$login === void 0 ? void 0 : _state$login.length) > 0;
  }
}, []);